import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { LandingPage } from './pages/LandingPage';
import { Terms } from './pages/Terms';
import { Privacy } from './pages/Privacy';
import { Analytics } from './components/Analytics';
import { ErrorBoundary } from './components/ErrorBoundary';
export function App() {
  return <ErrorBoundary data-id="element-0">
      <HashRouter data-id="element-1">
        <Analytics data-id="element-2" />
        <Routes data-id="element-3">
          <Route path="/" element={<LandingPage data-id="element-5" />} data-id="element-4" />
          <Route path="/terminos" element={<Terms data-id="element-7" />} data-id="element-6" />
          <Route path="/privacidad" element={<Privacy data-id="element-9" />} data-id="element-8" />
        </Routes>
      </HashRouter>
    </ErrorBoundary>;
}